import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useClient } from "../../context/ClientContext";

export const AdminRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const { clientId , clientPath} = useClient();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to={clientPath('/login')} replace />;
  // El vendedor no tiene nada que hacer en el resto del admin: se lo manda a
  // su pantalla en vez de expulsarlo a la tienda, que es desorientador.
  if (user?.id_rol === 3) return <Navigate to={clientPath('/admin/venta')} replace />;
  if (user?.id_rol === 4) return <Navigate to={clientPath('/admin/cobros')} replace />;
  if (user?.id_rol !== 1) return <Navigate to={`/${clientId}`} replace />;

  return children;
};
